import classNames from "classnames";
import { useState } from "react";
import { EventCreationInputKeys } from "../../event_creation";
import { Tag } from "./base_components/tag";

const Sections = {
	RSVPs: ["rsvp_options"],
	Notifications: ["server_reminders"],
	Appearance: ["color", "image_url", "hide_attendees"],
	Attendees: [
		"eligible_role_ids",
		"attendee_role_data",
		"rsvp_lock_before_ms",
	],
	Integrations: ["thread_settings", "native_event_data"],
	Repeat: ["rrule"],
} satisfies Record<string, EventCreationInputKeys[]>;

const SectionIcons = {
	RSVPs: "fas fa-check-square",
	Appearance: "fas fa-palette",
	Attendees: "fas fa-users",
	Integrations: "fab fa-discord",
	Notifications: "fas fa-bell",
	Repeat: "fas fa-redo",
} satisfies Record<keyof typeof Sections, string>;

const NewSections: (keyof typeof Sections)[] = ["Notifications"];

export function EventCreationAdvancedSelector(props: {
	field_key_to_element: Record<string, Function>;
	is_disabled?: boolean;
}) {
	const [active_section, setActiveSection] = useState(
		Object.keys(Sections)[0] as keyof typeof Sections
	);

	return (
		<>
			{/* <div className="my-2 text-center text-lg font-bold">
				Advanced Settings
			</div> */}
			<div className="flex flex-col">
				<div className="w-fit self-center rounded-t-md bg-base-dark px-4 text-lg">
					Advanced
				</div>
				<div className="flex justify-between overflow-auto rounded-t-md bg-base-dark">
					{Object.keys(Sections).map(
						(section_name: keyof typeof Sections, index) => (
							<SectionIcon
								key={section_name}
								section_name={section_name}
								is_active={section_name === active_section}
								onClick={() => setActiveSection(section_name)}
								is_first={index === 0}
								is_last={
									index === Object.keys(Sections).length - 1
								}
							/>
						)
					)}
				</div>
				<div className="improved-event-creation-form flex flex-col gap-4 bg-base-semidark px-0 py-2">
					{Sections[active_section].map(
						(field_key: EventCreationInputKeys) =>
							props.field_key_to_element[field_key](
								props.is_disabled
							)
					)}
				</div>
			</div>
		</>
	);
}

function SectionIcon(props: {
	is_first?: boolean;
	is_last?: boolean;
	section_name: keyof typeof Sections;
	is_active: boolean;
	onClick: () => void;
}) {
	return (
		<div
			onClick={props.onClick}
			className={classNames("relative w-full cursor-pointer p-2 py-4", {
				"opacity-50": !props.is_active,
				"bg-base-semidark": props.is_active,
				"rounded-tl-md": props.is_first,
				"rounded-tr-md": props.is_last,
			})}
		>
			{NewSections.includes(props.section_name) && (
				<div className="absolute right-0 top-0">
					<Tag type="Light">New</Tag>
				</div>
			)}
			<div className="flex w-full flex-col items-center justify-center">
				<div className="text-2xl">
					<i className={SectionIcons[props.section_name]}></i>
				</div>
				<div className="hidden sm:flex">{props.section_name}</div>
			</div>
		</div>
	);
}
